export default "__VITE_ASSET__1bd353e4__"